import { Component, OnInit,ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from "../../../api.service";
import { NgForm } from '@angular/forms';
import { CommonService } from '../../../shared/common.service';
import { HostListener } from '@angular/core';

@Component({
  selector: 'app-follow-up-visit',
  templateUrl: './follow-up-visit.component.html',
  styleUrls: ['./follow-up-visit.component.scss']
})
export class FollowupVisitComponent implements OnInit {
   @ViewChild('form') form!: NgForm;
  formName: string | null = null; // To store the formName parameter
  studyId: string | null = null;
  subjectId: string | null = null;
  queryParams: any = {};
  studyDetails: any;
  subjectName: any;
  dataEntryDisabled: boolean = false;

  // Form data model
  formData = {
    visitNo: null,
    visitDate: '',
    vitalSigns: '',
    vitalSignsComments: '',
    physicalExam: '',
    physicalExamComments: '',
    labInvestigation: '',
    labInvestigationComments: '',
    sampleCollectionDate: '',
    pregnancyStatus: '',
    weight: null,
    height: null,
    waistCircumference: null,
    weightLossPrevious: null,
    weightLossBaseline: null,
    waistDifferencePrevious: null,
    waistDifferenceBaseline: null,
    bmi: null as string | null,
    productRetrieved: '',
    studyComments: '',
    asanaDispensedPrevious: null,
    asanaQuantityPrevious: null,
    asanaRetrievedCurrent: null,
    triphalaDispensedPrevious: null,
    triphalaQuantityPrevious: null,
    triphalaRetrievedCurrent: null,
    yavaDispensedPrevious: null,
    yavaQuantityPrevious: null,
    yavaRetrievedCurrent: null,
    asanaCompliance: '',
    asanaFirstDate: '',
    asanaLastDate: '',
    asanaConsumed: null,
    asanaIdealConsumed: null,
    asanaMissed: null,
    asanaCompliancePercentage: null,
    triphalaCompliance: '',
    triphalaFirstDate: '',
    triphalaLastDate: '',
    triphalaConsumed: null,
    triphalaIdealConsumed: null,
    triphalaMissed: null,
    triphalaCompliancePercentage: null,
    yavaCompliance: '',
    yavaFirstDate: '',
    yavaLastDate: '',
    yavaConsumed: null,
    yavaIdealConsumed: null,
    yavaMissed: null,
    yavaCompliancePercentage: null,
    dispensedProtocol: '',
    logGiven: '',
    dispensingDate: '',
    asanaDispensedCurrent: null,
    asanaQuantityCurrent: null,
    asanaBatch: null,
    asanaExpiry: '',
    triphalaDispensedCurrent: null,
    triphalaQuantityCurrent: null,
    triphalaBatch: null,
    triphalaExpiry: '',
    yavaDispensedCurrent: null,
    yavaQuantityCurrent: null,
    yavaBatch: null,
    yavaExpiry: '',
    adverseEvent: '',
    concomitantMedication: '',
    investigatorSignature: '',
    endDate: '',
    triphalaComplianceComments: '',
    yavaComplianceComments: '',
    studyComplianceComments: '',
    logGivenComments: '',
    dispensedProtocolComments: '',
    lmpDate: '',     // Date of Last Menstrual Period
    uptDone: '',     // Urine Pregnancy Test done (Yes/No)
    uptResult: '',
  };
  studyCode: any;
  studyName: any;
  siteLocation: any;
  todayDate: string;
  screeningMinDate: string;
  
  informedConsentDate: string;
  gender: any;
  //query code
   tabs = [
  { title: 'Query', type: 'query' },
  { title: 'Field History', type: 'fieldHistory' }
];

  fieldHistoryData: any[] = [];
  selectedTab = 0;
  isOptionsModalOpen = false;
  isModalOpen = false;
  queryText = '';
  // closeQuery = false;
  auditTrail: { user: string; role: string; timestamp: string; message: string }[] = [];
  queries: { threadId: string; text: string; isClosed:boolean; auditTrail: { user: string; role: string; timestamp: string; message: string }[] }[] = [
  {  threadId: this.generateThreadId(), text: '', isClosed: false , auditTrail: [] }
];
  selectedOption = 'query'; // Default to Query section
 showReviewModal = false;
  query: { auditTrail: any; };
  fieldLabel: string | null = null; // Add this at the top
  // query code end

  //edit thing
  isVisitNoDisabled: boolean=false;
  isDateOfVisitDisabled:boolean=false;
isVitalSignDisabled:boolean=false;
isPhysicalExamDisabled:boolean=false;
isLabDisabled:boolean=false;
isDateofSampleDisabled:boolean=false;
isLMPDateDisabled:boolean=false;
isUPTDoneDisabled:boolean=false;
isUPTResultDisabled:boolean=false;
isWeightDisabled:boolean=false;
isHeightDisabled:boolean=false;
isWaistDisabled:boolean=false;
isRetrievedDisabled:boolean=false;
isAdverseDisabled:boolean=false;
isAdverseDisabled2:boolean=false;
isWeightLossPreviousDisabled:boolean=false;
isWeightLossBaselineDisabled:boolean=false;
isWaistDifferencePreviousDisabled:boolean=false;
isWaistDifferenceBaselineDisabled:boolean=false;
isBMIDisabled:boolean=false;
isStudyComplainceDisabled:boolean=false;
isAsanaFirstDateDisabled:boolean=false;
isAsanaLastDateDisabled:boolean=false;
isAsanaConsumedDisabled:boolean=false;
isAsanaIdealDisabled:boolean=false;
isAsanaMissedDisabled:boolean=false;
isAsanaPercentageDisabled:boolean=false;
isTriphalaComplianceDisabled:boolean=false;
isTriphalaFirstDateDisabled:boolean=false;
isTriphalaLastDateDisabled:boolean=false;
isTriphalaConsumedDisabled:boolean=false;
isTriphalaIdealDisabled:boolean=false;
isTriphalaMissedDisabled:boolean=false;
isTriphalaPercentageDisabled:boolean=false;
isYavaComplianceDisabled:boolean=false;
isYavaFirstDateDisabled:boolean=false;
isYavaLastDateDisabled:boolean=false;
isYavaConsumedDisabled:boolean=false;
isYavaIdealDisabled:boolean=false;
isYavaMissedDisabled:boolean=false;
isYavaPercentageDisabled:boolean=false;
isAsanaDispensedDisabled:boolean=false;
isAsanaQuantityDisabled:boolean=false;
isAsanaRetrievedDisabled:boolean=false;
isTriphalaDispensedDisabled:boolean=false;
isTriphalaQuantityDisabled:boolean=false;
isTriphalaRetrievedDisabled:boolean=false;
isYavaDispensedDisabled:boolean=false;
isYavaQuantityDisabled:boolean=false;
isYavaRetrievedDisabled:boolean=false;
isDispensedProtocolDisabled:boolean=false;
isLogGivenDisabled:boolean=false;
isDispensingDateDisabled:boolean=false;
isAsanaSachetsDisabled:boolean=false;
isAsanaStudyDisabled:boolean=false;
isAsanaBatchDisabled:boolean=false;
isAsanaExpiryDisabled:boolean=false;
isTriphalaSachetsDisabled:boolean=false;
isTriphalaStudyDisabled:boolean=false;
isTriphalaBatchDisabled:boolean=false;
isTriphalaExpiryDisabled:boolean=false;
isYavaSachetsDisabled:boolean=false;
isYavaStudyDisabled:boolean=false;
isYavaBatchDisabled:boolean=false;
isYavaExpiryDisabled:boolean=false;






   isReasonModalOpen: boolean = false;
  editReason: string = '';

  currentYear = new Date().getFullYear();
  screeningDateMin: string;
  
  private questionMapping: { [key: string]: { question: string, field: string }[] } = {
    'follow-up-visit': [
      { question: '1. Follow Up Visit No:', field: 'visitNo' },
      { question: '2. Date of Visit:', field: 'visitDate' }
    ],
    'follow-up-vital-signs': [
      { question: '1. Was Vital Signs evaluation performed', field: 'vitalSigns' },
    ],
    'follow-up-physical': [
      { question: '1. Was physical and systematic examination performed', field: 'physicalExam' },
    ],
    'follow-up-laboratory-investigation': [
      { question: '1. Was Laboratory Investigation performed', field: 'labInvestigation' },
      { question: '2. Date of Sample Collection:', field: 'sampleCollectionDate' }
    ],
    'follow-up-pregnancy-declaration': [
      { question: 'Date of Last Menstrual Period (LMP)', field: 'lmpDate' },
  { question: 'Was Urine Pregnancy Test (UPT) done', field: 'uptDone' },
  { question: 'UPT Result', field: 'uptResult' }
    ],
    'follow-up-anthropometric-data': [
      { question: '1. Weight (kg):', field: 'weight' },
      { question: '2. Height (m):', field: 'height' },
      { question: '3. Waist Circumference (cm):', field: 'waistCircumference' },
      { question: '4. Weight-loss from previous visit (kg):', field: 'weightLossPrevious' },
      { question: '5. Weight-loss since baseline visit (kg):', field: 'weightLossBaseline' },
      { question: '6. Difference in Waist circumference from previous visit (cm):', field: 'waistDifferencePrevious' },
      { question: '7. Difference in Waist circumference since baseline visit (cm):', field: 'waistDifferenceBaseline' },
      { question: '8. Body Mass Index (BMI):', field: 'bmi' }
    ],
    'follow-up-product-retrieval': [
      { question: 'Was the Study Product retrieved from subject as per protocol', field: 'productRetrieved' },
    ],
    'follow-up-product-accountability': [
      { question: 'Total Number of sachets/boxes dispensed in previous visit (Asana Churna herbal drink):', field: 'asanaDispensedPrevious' },
      { question: 'Total Study Product quantity dispensed in previous visit (g) (Asana Churna herbal drink):', field: 'asanaQuantityPrevious' },
      { question: 'Total Number of sachets/boxes retrieved in current visit (Asana Churna herbal drink):', field: 'asanaRetrievedCurrent' },
      { question: 'Total Number of sachets/boxes dispensed in previous visit (Triphala tablet):', field: 'triphalaDispensedPrevious' },
      { question: 'Total Study Product quantity dispensed in previous visit (g) (Triphala tablet):', field: 'triphalaQuantityPrevious' },
      { question: 'Total Number of sachets/boxes retrieved in current visit (Triphala tablet):', field: 'triphalaRetrievedCurrent' },
      { question: 'Total Number of sachets/boxes dispensed in previous visit (Yava Churna):', field: 'yavaDispensedPrevious' },
      { question: 'Total Study Product quantity dispensed in previous visit (g) (Yava Churna):', field: 'yavaQuantityPrevious' },
      { question: 'Total Number of sachets/boxes retrieved in current visit (Yava Churna):', field: 'yavaRetrievedCurrent' }
    ],
    'follow-up-product-compliance': [
      { question: 'Is the subject compliant with the usage of Study Product as per the protocol (Asana Churna)', field: 'asanaCompliance' },
      { question: 'Date of first Study Product consumed (Asana Churna):', field: 'asanaFirstDate' },
      { question: 'Date of last Study Product consumed (Asana Churna):', field: 'asanaLastDate' },
      { question: 'Total quantity of Study Product consumed (g) (Asana Churna):', field: 'asanaConsumed' },
      { question: 'Total quantity of Study Product should ideally be consumed (g) (Asana Churna):', field: 'asanaIdealConsumed' },
      { question: 'Total quantity missed (Asana Churna):', field: 'asanaMissed' },
      { question: 'Compliance (%) (Asana Churna):', field: 'asanaCompliancePercentage' },
      { question: 'Is the subject compliant with the usage of Study Product as per the protocol (Triphala)', field: 'triphalaCompliance' },
      { question: 'Date of first Study Product consumed (Triphala):', field: 'triphalaFirstDate' },
      { question: 'Date of last Study Product consumed (Triphala):', field: 'triphalaLastDate' },
      { question: 'Total quantity of Study Product consumed (g) (Triphala):', field: 'triphalaConsumed' },
      { question: 'Total quantity of Study Product should ideally be consumed (g) (Triphala):', field: 'triphalaIdealConsumed' },
      { question: 'Total quantity missed (Triphala):', field: 'triphalaMissed' },
      { question: 'Compliance (%) (Triphala):', field: 'triphalaCompliancePercentage' },
      { question: 'Is the subject compliant with the usage of Study Product as per the protocol (Yava Churna)', field: 'yavaCompliance' },
      { question: 'Date of first Study Product consumed (Yava Churna):', field: 'yavaFirstDate' },
      { question: 'Date of last Study Product consumed (Yava Churna):', field: 'yavaLastDate' },
      { question: 'Total quantity of Study Product consumed (g) (Yava Churna):', field: 'yavaConsumed' },
      { question: 'Total quantity of Study Product should ideally be consumed (g) (Yava Churna):', field: 'yavaIdealConsumed' },
      { question: 'Total quantity missed (Yava Churna):', field: 'yavaMissed' },
      { question: 'Compliance (%) (Yava Churna):', field: 'yavaCompliancePercentage' },
    ],
    'follow-up-product-dispensing-record': [
      { question: '1. Were all the Study Products dispensed to the subject as per protocol', field: 'dispensedProtocol' },
      { question: '3. Was the Daily Product Consumption Log given to the subject', field: 'logGiven' },
      { question: '5. Date of dispensing of the Study Products:', field: 'dispensingDate' },
      { question: '6. Total Number of sachets/boxes dispensed (Asana Churna herbal drink):', field: 'asanaDispensedCurrent' },
      { question: '7. Total Study Product quantity dispensed (g) (Asana Churna herbal drink):', field: 'asanaQuantityCurrent' },
      { question: '8. Batch Number (Asana Churna herbal drink):', field: 'asanaBatch' },
      { question: '9. Date of Expiry (Asana Churna herbal drink):', field: 'asanaExpiry' },
      { question: '10. Total Number of sachets/boxes dispensed (Triphala tablet):', field: 'triphalaDispensedCurrent' },
      { question: '11. Total Study Product quantity dispensed (g) (Triphala tablet):', field: 'triphalaQuantityCurrent' },
      { question: '12. Batch Number (Triphala tablet):', field: 'triphalaBatch' },
      { question: '13. Date of Expiry (Triphala tablet):', field: 'triphalaExpiry' },
      { question: '14. Total Number of sachets/boxes dispensed (Yava Churna):', field: 'yavaDispensedCurrent' },
      { question: '15. Total Study Product quantity dispensed (g) (Yava Churna):', field: 'yavaQuantityCurrent' },
      { question: '16. Batch Number (Yava Churna):', field: 'yavaBatch' },
      { question: '17. Date of Expiry (Yava Churna):', field: 'yavaExpiry' }
    ],
    'follow-up-adverse-events': [
      { question: 'Did the subject experience any adverse event since last visit', field: 'adverseEvent' },
      { question: 'Did the subject take any new or change in concomitant medications since last visit', field: 'concomitantMedication' }
    ]
  };
  folderName: any;
  showError: boolean;
//review code
isReviewCheckboxDisabled: boolean = true;
userDesignation: string = '';

   constructor( private apiService: ApiService,private route: ActivatedRoute, private router: Router,private commonService: CommonService) {}
  
  calculateBMI(): void {
    const weight = this.formData.weight;
    const height = this.formData.height;

    if (weight && height) {
      const bmi = (weight / (height * height)).toFixed(2);
      this.formData.bmi = bmi;
    } else {
      this.formData.bmi = null;
    }
  }
  ngOnInit(): void {

    const userData = this.commonService.getUserData();
  console.log('User Data from Cookie:', userData);

  const isLoggedIn = this.commonService.isLoggedIn();
  console.log('Is Logged In:', isLoggedIn);

    console.log('ngOnInit Executed');
    const today = new Date();
  const day = String(today.getDate()).padStart(2, '0');
  const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = today.getFullYear();
  this.todayDate = `${year}-${month}-${day}`; // Format for input type="date"
   
    this.informedConsentDate = ''; // Start with an empty value
    this.screeningMinDate = ''; // Same for screeningMinDate

    // Get the formName parameter from the route
    this.route.paramMap.subscribe(params => {
      this.folderName = params['folderName'] ?? 'follow-up-visit';
      this.formName = params.get('formName');
      console.log('Form Name:', this.formName, 'folder name', this.folderName); // Debugging log
     this.checkAndCallApi();
    });
    
    
    // Get query parameters (studyId and subjectId)
    this.route.queryParams.subscribe(params => {
      this.studyId = params['studyId'];
      this.subjectId = params['subjectId'];
      console.log('Study ID:', this.studyId); // Debugging log
      console.log('Subject ID:', this.subjectId); // Debugging log
     this.checkAndCallApi();
    });
    console.log("Extracted Params:", {
      studyId: this.studyId,
      subjectId: this.subjectId,
      folderName: this.folderName,
      formName: this.formName
    });
  }
    checkAndCallApi() {
    if (this.studyId && this.subjectId && this.folderName && this.formName) {
      this.apiService.getFormData(this.studyId, this.subjectId, this.folderName, this.formName).subscribe({
        next: (response) => {
          console.log('Fetched Form Data:', response);
          if (response.success) {
           // Ensure response.data is an array before mapping
           if (Array.isArray(response.data)) {
            this.mapFormData(response.data);
          } else {
            console.warn('Form data is not an array or is missing.');
          }
          this.mapStudyDetails(response.studyDetails);

          // Dynamically update informedConsentDate from the response
          if (response.informedConsentDate !== undefined) {
            this.informedConsentDate = response.informedConsentDate;
            this.screeningMinDate = this.informedConsentDate;  // Set min date
            console.log("Informed Consent Date:", this.informedConsentDate);
          } else {
            console.warn('Informed consent date is missing in the response.');
          }
           // Store the gender from the response
           this.gender = response.gender;
           console.log("gender:",this.gender);
        }
        },
        error: (error) => {
          console.error('Error fetching form data:', error);
        }
      });
      const fieldName = this.fieldLabel || 'Unknown Field';
  this.apiService.getInsertHistoryData(this.studyId, this.subjectId, this.folderName, this.formName, fieldName)
    .subscribe({
      next: (response) => {
        console.log('Fetched Field History for', fieldName, response);
        this.fieldHistoryData = response.data || [];
      },
      error: (error) => {
        console.error('Error fetching field history data:', error);
      }
    });

     } else {
      console.error('Missing required parameters: studyId, subjectId, folderName, or formName.');
    }
  }
addTab(label: string = 'Date of Study Completion') {
  const fieldName = label.trim(); // You can enhance this mapping if needed

  this.apiService.getInsertHistoryData(this.studyId, this.subjectId, this.folderName, this.formName, fieldName)
    .subscribe({
      next: (response) => {
        console.log('Fetched Field History for', fieldName, response);
        this.fieldHistoryData = response.data || [];
        
        // Add tab only after fetching data
        this.tabs.push({ title: 'Field History', type: 'fieldHistory' });
        this.selectedTab = this.tabs.length - 1;
      },
      error: (error) => {
        console.error('Error fetching field history data:', error);
      }
    });
}


generateThreadId(): string {
  return 'thread-' + Math.random().toString(36).substr(2, 9);
}







  selectTab(index: number) {
    this.selectedTab = index;
    const selected = this.tabs[index];
  if (selected.type === 'query') {
    // const fieldName = '2. Date of Study Completion:'; // Or dynamically set based on tab
    const fieldName = this.fieldLabel || 'Unknown Field';
    console.log('Fetching Query History for Field:', fieldName); // <-- Add this
    this.apiService.getQueryHistoryData(
      this.studyId,
      this.subjectId,
      this.folderName,
      this.formName,
      fieldName
    ).subscribe({
      next: (response) => {
        console.log('Fetched Query History Data:', response);
        // You can decide how to display this – either integrate it into the auditTrail or a dedicated UI block
        // Example: populate audit trails per query
         if (response.data && Array.isArray(response.data)) {
          const auditTrail = response.data.map((item: any) => {
            const subData = item.sub_data ? JSON.parse(item.sub_data) : {};
            return {
              user: item.updated_by || 'Unknown',
              
              timestamp: subData.timestamp || item.updated_at,
              message: item.value || ''
            };
          });
       
        }
      },
      error: (error) => {
        console.error('Error fetching query history data:', error);
      }
    });
  }
  if (selected.type === 'fieldHistory') {
    const fieldName = this.fieldLabel || 'Unknown Field';
    console.log('Fetching Field History for:', fieldName);
    this.apiService.getInsertHistoryData(
      this.studyId,
      this.subjectId,
      this.folderName,
      this.formName,
      fieldName
    ).subscribe({
      next: (response) => {
        console.log('Fetched Field History Data:', response);
        this.fieldHistoryData = response.data || [];
      },
      error: (error) => {
        console.error('Error fetching field history data:', error);
      }
    });
  }

}
  
  closeTab(index: number, event: MouseEvent) {
    event.stopPropagation();
    this.tabs.splice(index, 1);
    if (this.selectedTab >= this.tabs.length) {
      this.selectedTab = this.tabs.length - 1;
    }
  }
openReviewModal() {
  this.showReviewModal = true;

  const fieldName = this.fieldLabel || 'Unknown Field';
  console.log('Opening Review Modal - Fetching Field History for:', fieldName);

  this.apiService.getInsertHistoryData(
    this.studyId,
    this.subjectId,
    this.folderName,
    this.formName,
    fieldName
  ).subscribe({
    next: (response) => {
      console.log('Fetched Field History Data (from review modal):', response);
      this.fieldHistoryData = response.data || [];

      // Initialize default review flags
      let latestReview = {
        dataMonitor: false,
        monitor: false,
        pi: false
      };

      // Sort descending by updated_at to get the latest ones first
      const sortedData = [...this.fieldHistoryData].sort((a, b) => new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime());

      const flagsFound = {
        dataMonitor: false,
        monitor: false,
        pi: false
      };

      for (const entry of sortedData) {
        if (!entry.review_status) continue;

        try {
          const parsed = JSON.parse(entry.review_status);

          // For each reviewer type, only update if not already found (i.e., get the latest one)
          if (!flagsFound.dataMonitor && parsed.hasOwnProperty('dataMonitor')) {
            latestReview.dataMonitor = parsed.dataMonitor;
            flagsFound.dataMonitor = true;
          }

          if (!flagsFound.monitor && parsed.hasOwnProperty('monitor')) {
            latestReview.monitor = parsed.monitor;
            flagsFound.monitor = true;
          }

          if (!flagsFound.pi && parsed.hasOwnProperty('pi')) {
            latestReview.pi = parsed.pi;
            flagsFound.pi = true;
          }

          // If all found, stop early
          if (flagsFound.dataMonitor && flagsFound.monitor && flagsFound.pi) {
            break;
          }

        } catch (err) {
          console.error("Error parsing review_status JSON:", err);
        }
      }

      this.reviewOptions = latestReview;
      console.log("✅ Final reviewOptions applied:", this.reviewOptions);
    },

    error: (error) => {
      console.error('Error fetching field history data from review modal:', error);
    }
  });
}

closeReviewModal() {
  this.showReviewModal = false;
}

openOptionsModal(event: MouseEvent, target: EventTarget | null) {
  event.stopPropagation();
  this.isOptionsModalOpen = true;

  // Traverse to the closest parent with `data-label`
  const icon = target as HTMLElement;
  const fieldGroup = icon.closest('.form-group');

 if (fieldGroup) {
    this.fieldLabel = fieldGroup.getAttribute('data-label');
    console.log('Dynamically captured label:', this.fieldLabel);
  }
}

openModal() {
  this.isModalOpen = true;
  this.selectedTab = 0; // Default to 'Query'

  // const fieldName = '2. Date of Study Completion:'; // Or dynamically get it
  const fieldName = this.fieldLabel || 'Unknown Field';
 console.log("Opening modal - Fetching field name:", fieldName); // <-- Add this

  this.apiService.getQueryHistoryData(
    this.studyId,
    this.subjectId,
    this.folderName,
    this.formName,
    fieldName
  ).subscribe({
    next: (response) => {
      console.log('Fetched Query History Data:', response);

      if (response.success && Array.isArray(response.data)) {
        this.queries = response.data.map((entry: any) => {
          const auditTrail = entry.auditTrail?.map((a: any) => ({
            user: a.user,
            timestamp: a.timestamp,
            message: typeof a.message === 'string' ? a.message : String(a.message)
          })) || [];

          const isClosed = auditTrail.some(item => 
  typeof item.message === 'string' && item.message.toLowerCase().includes('query closed')
);

const query = {
  threadId: entry.threadId || 'no-thread',
  text: this.getInitialQueryText(auditTrail) || '',
  isClosed: isClosed,
  auditTrail: auditTrail
};

         

          return query;
        });
      } else {
        // Fallback for empty or invalid data
        this.queries = Array(3).fill(null).map(() => ({
          threadId: this.generateThreadId(),
          text: '',
          isClosed: false,
          auditTrail: []
        }));
      }
    },
    error: (error) => {
      console.error('Error fetching query history:', error);
      this.queries = [{
        threadId: this.generateThreadId(),
        text: '',
        isClosed: false,
        auditTrail: []
      }];
    }
  });
}

getInitialQueryText(auditTrail: any[]): string {
  if (!Array.isArray(auditTrail)) return '';

  // Look for latest message or first valid message in each query's auditTrail
  const validEntry = auditTrail
    .filter(a => typeof a.message === 'string' && a.message.trim() && a.message.toLowerCase() !== 'query closed')
    .pop(); // or use [0] for first message

  return validEntry ? validEntry.message : '';
}

closeModal() {
  this.isModalOpen = false;
  document.body.classList.remove('modal-open');
}


addQuery(index: number) {
  this.queries.splice(index + 1, 0, {
    threadId: this.generateThreadId(),
    text: '',
    isClosed: false,
    auditTrail: []
  });
}
submitQuery(index: number) {
  const userData = this.commonService.getUserData(); // Extract from cookies
  console.log('userData:', userData); // Check the structure
  const fullName = `${userData.first_name} ${userData.last_name}`;
  const designation = userData.designation || 'N/A'; // Fallback if not available

  const timestamp = new Date().toISOString(); // ISO format for backend

  const query = this.queries[index];

  if (!query.text || !query.text.trim()) {
    console.warn('No text entered for this query. Ignoring submit.');
    return;
  }

  // Ensure threadId
  if (!query.threadId) {
    query.threadId = this.generateThreadId();
  }

  const payloadItem = {
    studyId: this.studyId,
    subjectId: this.subjectId,
    folderName: this.folderName,
    formName: this.formName,
    // fieldName: '2. Date of Study Completion:',
    fieldName :this.fieldLabel || 'Unknown Field',
    threadId: query.threadId,
    queryText: query.text.trim(),
    user: fullName,
    designation: designation,
    timestamp: timestamp,
    
  };
   console.log('Submitting Query Payload:', payloadItem); // <-- Important log

  this.apiService.submitQueryData([payloadItem]).subscribe({
    next: (response) => {
      console.log('Query submitted:', response);

      query.auditTrail = query.auditTrail || [];
      query.auditTrail.push({
        user: fullName,
        role: designation,
        timestamp: new Date().toLocaleString(),
        message: payloadItem.queryText
      });
 query.text = ''; // Clear only this one
    },
    error: (error) => {
      console.error('Error submitting query:', error);
    }

     
    });
  }

reviewOptions = {
  dataMonitor: false,
  monitor: false,
  pi: false
};
 
confirmCloseQuery(index: number): void {
  const confirmed = window.confirm('Are you sure you want to close this query?');
  if (confirmed) {
    this.closeQuery(index);
  }
}
closeQuery(index: number): void {
  const userData = this.commonService.getUserData();
  const fullName = `${userData.first_name} ${userData.last_name}`;
  const designation = userData.designation || 'N/A';
  const timestamp = new Date().toISOString(); // For backend
  const localTime = new Date().toLocaleString(); // For UI

  const query = this.queries[index];
  if (!query.threadId) {
    query.threadId = this.generateThreadId();
  }

  const closeMessage = 'Query closed';

  const payloadItem = {
    studyId: this.studyId,
    subjectId: this.subjectId,
    folderName: this.folderName,
    formName: this.formName,
    // fieldName: '2. Date of Study Completion:',
    fieldName : this.fieldLabel || 'Unknown Field',
    threadId: query.threadId,
    queryText: closeMessage,
    user: fullName,
    designation: designation,
    timestamp: timestamp,
    isClosed: true  // Optional, in case your backend expects a flag
  };

  this.apiService.submitQueryData([payloadItem]).subscribe({
    next: (response) => {
      console.log('Query closed:', response);
      

      query.auditTrail = query.auditTrail || [];
      query.auditTrail.push({
        user: fullName,
        role: designation,
        timestamp: localTime,
        message: closeMessage
      });
      query.isClosed = true;
      alert('Query closed successfully');
    },
    error: (error) => {
      console.error('Error closing query:', error);
    }
  });
}
confirmSubmitQuery(index: number): void {
  const confirmSubmit = confirm('Are you sure you want to submit the data?');
  if (confirmSubmit) {
    this.submitQuery(index);
    alert('Data submitted successfully');
  }
}





  // Function to map study details
  mapStudyDetails(studyDetails: any): void {
    if (studyDetails) {
      this.studyCode = studyDetails.study_code;
      this.studyName = studyDetails.study_name;
      this.siteLocation = studyDetails.site_location;
      this.subjectName = this.subjectId; // Mapping subjectId to subjectName
    }
  }
hasStudyCompleteData = false;
hasVisitNoData=false;
hasVisitDData=false;
hasVitalSignData=false;
hasPhysicalExamData=false;
hasLabData=false;
hasSampleDData=false;
hasLMPData=false;
hasUPTData=false;
hasUPTResultData=false;
hasWeightData=false;
hasHeightData=false;
hasWaistData=false;
hasWLPreviousData=false;
hasWLBaselineData=false;
hasWCPreviousData=false;
hasWCBaselineData=false;
hasBMIData=false;
hasRetrievedData=false;
hasAsanaSachetsData=false;
hasAsanaQuantityData=false;
hasAsanaRetrievedData=false;
hasTriphalaSachetsData=false;
hasTriphalaQuantityData=false;
hasTriphalaRetrievedData=false;
hasYavaSachetsData=false;
hasYavaQuantityData=false;
hasYavaRetrievedData=false;
hasAsanaComplianceData=false;
hasAsanaFDData=false;
hasAsanaLDData=false;
hasAsanaConsumedData=false;
hasAsanaIdealData=false;
hasAsanaMissedData=false;
hasAsanaperData=false;
hasTriphalaComplianceData=false;
hasTriphalaFDData=false;
hasTriphalaLDData=false;
hasTriphalaConsumedData =false;

//Bad luck
hasTriphalaIdealData=false;
hasTriphalaMissedData=false;
hasTriphalaPerData =false;
hasYavaComplianceData=false;
hasYavaFDData=false;
hasYavaLDData=false;
hasYavaConsumedData=false;
hasYavaIdealData=false;
hasYavaMissedData=false;
hasYavaPerData =false;
hasDProtocolData =false;
hasLogData=false;
hasDispensingDateData=false;
hasAsanaSDData=false;
hasAsanaQData=false;
hasAsanaBatchData =false;
hasAsanaExpiryData =false;
hasTriphalaSDData=false;
hasTriphalaQData =false;
hasTriphalaBatchData =false;
hasTriphalaExpiryData =false;
hasYavaSDData=false;
hasYavaQData=false;
hasYavaBatchData=false;
hasYavaExpiryData=false;
hasAdverse1Data =false;
hasAdverse2Data =false;

  mapFormData(data: any[]): void {
    this.hasStudyCompleteData = false;
    this.hasVisitNoData=false;
    this.hasVisitDData=false;
    this.hasVitalSignData=false;
    this.hasPhysicalExamData=false;
    this.hasLabData=false;
    this.hasSampleDData=false;
    this.hasLMPData=false;
    this.hasUPTData=false;
    this.hasUPTResultData=false;
    this.hasWeightData=false;
    this.hasHeightData=false;
    this.hasWaistData=false;
    this.hasWLPreviousData=false;
    this.hasWLBaselineData=false;
    this.hasWCPreviousData=false;
    this.hasWCBaselineData=false;
    this.hasBMIData=false;
    this.hasRetrievedData=false;
    this.hasAsanaSachetsData=false;
    this.hasAsanaQuantityData=false;
    this.hasAsanaRetrievedData=false;
this.hasTriphalaSachetsData=false;
this.hasTriphalaQuantityData=false;
this.hasTriphalaRetrievedData=false;
this.hasYavaSachetsData=false;
this.hasYavaQuantityData=false;
this.hasYavaRetrievedData=false;
this.hasAsanaComplianceData=false;
this.hasAsanaFDData=false;
this.hasAsanaLDData=false;
this.hasAsanaConsumedData=false;
this.hasAsanaIdealData=false;
this.hasAsanaMissedData=false;
this.hasAsanaperData=false;
this.hasTriphalaComplianceData=false;
this.hasTriphalaFDData=false;
this.hasTriphalaLDData=false;
this.hasTriphalaConsumedData =false;
this.hasTriphalaIdealData=false;
this.hasTriphalaMissedData=false;
this.hasTriphalaPerData =false;
this.hasYavaComplianceData=false;
this.hasYavaFDData=false;
this.hasYavaLDData=false;
this.hasYavaConsumedData=false;
this.hasYavaIdealData=false;
this.hasYavaMissedData=false;
this.hasYavaPerData =false;
this.hasDProtocolData =false;
this.hasLogData=false;
this.hasDispensingDateData=false;
this.hasAsanaSDData=false;
this.hasAsanaQData=false;
this.hasAsanaBatchData =false;
this.hasAsanaExpiryData =false;
this.hasTriphalaSDData=false;
this.hasTriphalaQData =false;
this.hasTriphalaBatchData =false;
this.hasTriphalaExpiryData =false;
this.hasYavaSDData=false;
this.hasYavaQData=false;
this.hasYavaBatchData=false;
this.hasYavaExpiryData=false;
this.hasAdverse1Data =false;
this.hasAdverse2Data =false;

    data.forEach(item => {
      const fieldName = item.field_name?.trim();
      const fieldValue = item.value;
       // Map checkbox values
    if (fieldName === 'reviewedByDataMonitor') this.reviewOptions.dataMonitor = fieldValue === 'true';
    if (fieldName === 'reviewedByMonitor') this.reviewOptions.monitor = fieldValue === 'true';
    if (fieldName === 'reviewedByPI') this.reviewOptions.pi = fieldValue === 'true';


      switch (fieldName) {
        case '1. Follow Up Visit No:':
          this.formData.visitNo = fieldValue;
           this.hasVisitNoData = !!fieldValue;
          this.isVisitNoDisabled=!!fieldValue;
          break;
        case '2. Date of Visit:':
          this.formData.visitDate = fieldValue;
           this.isDateOfVisitDisabled=!!fieldValue;
           this.hasVisitDData=!!fieldValue;
          break;
        case '1. Was Vital Signs evaluation performed':
          this.formData.vitalSigns = fieldValue;
          this.isVitalSignDisabled=!!fieldValue;
          this.hasVitalSignData=!!fieldValue;
          if (fieldValue === 'no') {
            this.formData.vitalSignsComments = item.sub_data ? item.sub_data.replace(/\\n/g, '\n') : null;
          }
          break;
        case '1. Was physical and systematic examination performed':
          this.formData.physicalExam = fieldValue;
          this.isPhysicalExamDisabled=!!fieldValue;
          this.hasPhysicalExamData=!!fieldValue;
          if (fieldValue === 'no') {
            this.formData.physicalExamComments = item.sub_data ? item.sub_data.replace(/\\n/g, '\n') : null;
          }
          break;
        case '1. Was Laboratory Investigation performed':
          this.formData.labInvestigation = fieldValue;
          this.hasLabData=!!fieldValue;
          this.isLabDisabled=!!fieldValue;
          if (fieldValue === 'no') {
            this.formData.labInvestigationComments = item.sub_data ? item.sub_data.replace(/\\n/g, '\n') : null;
          }
          break;
        case '2. Date of Sample Collection:':
          this.formData.sampleCollectionDate = fieldValue;
          this.isDateofSampleDisabled=!!fieldValue;
          this.hasSampleDData=!!fieldValue;
          break;
          case 'Date of Last Menstrual Period (LMP)':
            this.formData.lmpDate = fieldValue;
            this.isLMPDateDisabled=!!fieldValue;
            this.hasLMPData=!!fieldValue; // Store LMP Date
            break;
          
          case 'Was Urine Pregnancy Test (UPT) done':
            this.formData.uptDone = fieldValue; 
            this.isUPTDoneDisabled=!!fieldValue;// Store UPT Done (YES/NO)
           this.hasUPTData=!!fieldValue;
            break;
          
          case 'UPT Result':
            this.formData.uptResult = fieldValue; 
            this.isUPTResultDisabled=!!fieldValue;// Store UPT Result (Positive/Negative)
           this.hasUPTResultData=!!fieldValue;
            break;
        case '1. Weight (kg):':
          this.formData.weight = fieldValue;
          this.isWeightDisabled=!!fieldValue;
          this.hasWeightData=!!fieldValue;
          break;
        case '2. Height (m):':
          this.formData.height = fieldValue;
          this.isHeightDisabled=!!fieldValue;
          this.hasHeightData=!!fieldValue;
                    break;
        case '3. Waist Circumference (cm):':
          this.formData.waistCircumference = fieldValue;
          this.isWaistDisabled=!!fieldValue;
          this.hasWaistData=!!fieldValue;
          break;
        case '4. Weight-loss from previous visit (kg):':
          this.formData.weightLossPrevious = fieldValue;
          this.isWeightLossPreviousDisabled=!!fieldValue;
          this.hasWLPreviousData=!!fieldValue;
          break;
        case '5. Weight-loss since baseline visit (kg):':
          this.formData.weightLossBaseline = fieldValue;
          this.isWeightLossBaselineDisabled=!!fieldValue;
          this.hasWLBaselineData=!!fieldValue;
          break;
        case '6. Difference in Waist circumference from previous visit (cm):':
          this.formData.waistDifferencePrevious = fieldValue;
         this.isWaistDifferencePreviousDisabled=!!fieldValue;
         this.hasWCPreviousData=!!fieldValue;
          break;
        case '7. Difference in Waist circumference since baseline visit (cm):':
          this.formData.waistDifferenceBaseline = fieldValue;
          this.isWaistDifferenceBaselineDisabled=!!fieldValue;
         this.hasWCBaselineData=!!fieldValue;
          break;
        case '8. Body Mass Index (BMI):':
          this.formData.bmi = fieldValue;
          this.isBMIDisabled=!!fieldValue;
          this.hasBMIData=!!fieldValue;
          break;
        case 'Was the Study Product retrieved from subject as per protocol':
          this.formData.productRetrieved = fieldValue;
          this.isRetrievedDisabled=!!fieldValue;
          this.hasRetrievedData=!!fieldValue;;
          if (fieldValue === 'no') {
            this.formData.studyComments = item.sub_data ? item.sub_data.replace(/\\n/g, '\n') : null;
          }
          break;
        case 'Total Number of sachets/boxes dispensed in previous visit (Asana Churna herbal drink):':
          this.formData.asanaDispensedPrevious = fieldValue;
          this.isAsanaDispensedDisabled=!!fieldValue;
          this.hasAsanaSachetsData=!!fieldValue;
          break;
        case 'Total Study Product quantity dispensed in previous visit (g) (Asana Churna herbal drink):':
          this.formData.asanaQuantityPrevious = fieldValue;
          this.isAsanaQuantityDisabled=!!fieldValue;
          this.hasAsanaQuantityData=!!fieldValue;
          break;
        case 'Total Number of sachets/boxes retrieved in current visit (Asana Churna herbal drink):':
          this.formData.asanaRetrievedCurrent = fieldValue;
          this.isAsanaRetrievedDisabled=!!fieldValue;
          this.hasAsanaRetrievedData=!!fieldValue;
          break;
        case 'Total Number of sachets/boxes dispensed in previous visit (Triphala tablet):':
          this.formData.triphalaDispensedPrevious = fieldValue;
          this.isTriphalaDispensedDisabled=!!fieldValue;
          this.hasTriphalaSachetsData=!!fieldValue;
          break;
        case 'Total Study Product quantity dispensed in previous visit (g) (Triphala tablet):':
          this.formData.triphalaQuantityPrevious = fieldValue;
          this.isTriphalaQuantityDisabled=!!fieldValue;
          this.hasTriphalaQuantityData=!!fieldValue;
          
          break;
        case 'Total Number of sachets/boxes retrieved in current visit (Triphala tablet):':
          this.formData.triphalaRetrievedCurrent = fieldValue;
          this.isTriphalaRetrievedDisabled=!!fieldValue;
          this.hasTriphalaRetrievedData=!!fieldValue;
          break;
        case 'Total Number of sachets/boxes dispensed in previous visit (Yava Churna):':
          this.formData.yavaDispensedPrevious = fieldValue;
          this.isYavaDispensedDisabled=!!fieldValue;
          this.hasYavaSachetsData=!!fieldValue;
          break;
        case 'Total Study Product quantity dispensed in previous visit (g) (Yava Churna):':
          this.formData.yavaQuantityPrevious = fieldValue;
          this.isYavaQuantityDisabled=!!fieldValue;
          this.hasYavaQuantityData=!!fieldValue;
          break;
        case 'Total Number of sachets/boxes retrieved in current visit (Yava Churna):':
          this.formData.yavaRetrievedCurrent = fieldValue;
          this.isYavaRetrievedDisabled=!!fieldValue;
          this.hasYavaRetrievedData=!!fieldValue;
          break;
        case 'Is the subject compliant with the usage of Study Product as per the protocol (Asana Churna)':
          this.formData.asanaCompliance = fieldValue;
          this.isStudyComplainceDisabled=!!fieldValue;
          this.hasAsanaComplianceData=!!fieldValue;
          if (fieldValue === 'no') {
            this.formData.studyComplianceComments = item.sub_data ? item.sub_data.replace(/\\n/g, '\n') : null;
          }
          break;
        case 'Date of first Study Product consumed (Asana Churna):':
          this.formData.asanaFirstDate = fieldValue;
          this.isAsanaFirstDateDisabled=!!fieldValue;
          this.hasAsanaFDData=!!fieldValue;
          break;
        case 'Date of last Study Product consumed (Asana Churna):':
          this.formData.asanaLastDate = fieldValue;
          this.isAsanaLastDateDisabled=!!fieldValue;
          this.hasAsanaLDData=!!fieldValue;
          break;
        case 'Total quantity of Study Product consumed (g) (Asana Churna):':
          this.formData.asanaConsumed = fieldValue;
          this.isAsanaConsumedDisabled=!!fieldValue;
          this.hasAsanaConsumedData=!!fieldValue;
          break;
        case 'Total quantity of Study Product should ideally be consumed (g) (Asana Churna):':
          this.formData.asanaIdealConsumed = fieldValue;
          this.isAsanaIdealDisabled=!!fieldValue;
          this.hasAsanaIdealData=!!fieldValue;
          break;
        case 'Total quantity missed (Asana Churna):':
          this.formData.asanaMissed = fieldValue;
          this.isAsanaMissedDisabled=!!fieldValue;
          this.hasAsanaMissedData=!!fieldValue;
          break;
          ;
        case 'Compliance (%) (Asana Churna):':
          this.formData.asanaCompliancePercentage = fieldValue;
          this.isAsanaPercentageDisabled=!!fieldValue;
          this.hasAsanaperData=!!fieldValue;
          break;
        case 'Is the subject compliant with the usage of Study Product as per the protocol (Triphala)':
          this.formData.triphalaCompliance = fieldValue;
          this.isTriphalaComplianceDisabled=!!fieldValue;
          this.hasTriphalaComplianceData=!!fieldValue;
          if (fieldValue === 'no') {
            this.formData.triphalaComplianceComments = item.sub_data ? item.sub_data.replace(/\\n/g, '\n') : null;
          }
          break;
        case 'Date of first Study Product consumed (Triphala):':
          this.formData.triphalaFirstDate = fieldValue;
          this.isTriphalaFirstDateDisabled=!!fieldValue;
          this.hasTriphalaFDData=!!fieldValue;
          break;
        case 'Date of last Study Product consumed (Triphala):':
          this.formData.triphalaLastDate = fieldValue;
          this.isTriphalaLastDateDisabled=!!fieldValue;
          this.hasTriphalaLDData=!!fieldValue;
          break;
        case 'Total quantity of Study Product consumed (g) (Triphala):':
          this.formData.triphalaConsumed = fieldValue;
          this.isTriphalaConsumedDisabled=!!fieldValue;
          this.hasTriphalaConsumedData =!!fieldValue;
          break;
        case 'Total quantity of Study Product should ideally be consumed (g) (Triphala):':
          this.formData.triphalaIdealConsumed = fieldValue;
          this.isTriphalaIdealDisabled=!!fieldValue;
          this.hasTriphalaIdealData=!!fieldValue;
          break;
        case 'Total quantity missed (Triphala):':
          this.formData.triphalaMissed = fieldValue;
          this.isTriphalaMissedDisabled=!!fieldValue;
          this.hasTriphalaMissedData=!!fieldValue;
          break;
        case 'Compliance (%) (Triphala):':
          this.formData.triphalaCompliancePercentage = fieldValue;
          this.isTriphalaPercentageDisabled=!!fieldValue;
          this.hasTriphalaPerData =!!fieldValue;
          break;
        case 'Is the subject compliant with the usage of Study Product as per the protocol (Yava Churna)':
          this.formData.yavaCompliance = fieldValue;
          this.isYavaComplianceDisabled=!!fieldValue;
          this.hasYavaComplianceData=!!fieldValue;
          if (fieldValue === 'no') {
            this.formData.yavaComplianceComments = item.sub_data ? item.sub_data.replace(/\\n/g, '\n') : null;
          }
          break;
        case 'Date of first Study Product consumed (Yava Churna):':
          this.formData.yavaFirstDate = fieldValue;
          this.isYavaFirstDateDisabled=!!fieldValue;
          this.hasYavaFDData=!!fieldValue;
          break;
        case 'Date of last Study Product consumed (Yava Churna):':
          this.formData.yavaLastDate = fieldValue;
          this.isYavaLastDateDisabled=!!fieldValue;
          this.hasYavaLDData=!!fieldValue;
          break;
        case 'Total quantity of Study Product consumed (g) (Yava Churna):':
          this.formData.yavaConsumed = fieldValue;
          this.isYavaConsumedDisabled=!!fieldValue;
          this.hasYavaConsumedData=!!fieldValue;
          break;
        case 'Total quantity of Study Product should ideally be consumed (g) (Yava Churna):':
          this.formData.yavaIdealConsumed = fieldValue;
          this.isYavaIdealDisabled=!!fieldValue;
          this.hasYavaIdealData=!!fieldValue;
          break;
        case 'Total quantity missed (Yava Churna):':
          this.formData.yavaMissed = fieldValue;
          this.isYavaMissedDisabled=!!fieldValue;
          this.hasYavaMissedData=!!fieldValue;
          break;
        case 'Compliance (%) (Yava Churna):':
          this.formData.yavaCompliancePercentage = fieldValue;
          this.isYavaPercentageDisabled=!!fieldValue;
          this.hasYavaPerData =!!fieldValue;
          break;
        case '1. Were all the Study Products dispensed to the subject as per protocol':
          this.formData.dispensedProtocol = fieldValue;
          this.isDispensedProtocolDisabled=!!fieldValue;
          this.hasDProtocolData =!!fieldValue;
          if (fieldValue === 'no') {
            this.formData.dispensedProtocolComments = item.sub_data ? item.sub_data.replace(/\\n/g, '\n') : null;
          }
          break;
        case '3. Was the Daily Product Consumption Log given to the subject':
          this.formData.logGiven = fieldValue;
          this.isLogGivenDisabled=!!fieldValue;
          this.hasLogData=!!fieldValue;
          if (fieldValue === 'no') {
            this.formData.logGivenComments = item.sub_data ? item.sub_data.replace(/\\n/g, '\n') : null;
          }
          break;
        case '5. Date of dispensing of the Study Products:':
          this.formData.dispensingDate = fieldValue;
          this.isDispensingDateDisabled=!!fieldValue;
          this.hasDispensingDateData=!!fieldValue;
          
          break;
        case '6. Total Number of sachets/boxes dispensed (Asana Churna herbal drink):':
          this.formData.asanaDispensedCurrent = fieldValue;
          this.isAsanaSachetsDisabled=!!fieldValue;
          this.hasAsanaSDData=!!fieldValue;
          break;
        case '7. Total Study Product quantity dispensed (g) (Asana Churna herbal drink):':
          this.formData.asanaQuantityCurrent = fieldValue;
          this.isAsanaStudyDisabled=!!fieldValue;
          this.hasAsanaQData=!!fieldValue;
          break;
        case '8. Batch Number (Asana Churna herbal drink):':
          this.formData.asanaBatch = fieldValue;
          this.isAsanaBatchDisabled=!!fieldValue;
          this.hasAsanaBatchData =!!fieldValue;
          break;
        case '9. Date of Expiry (Asana Churna herbal drink):':
          this.formData.asanaExpiry = fieldValue;
          this.isAsanaExpiryDisabled=!!fieldValue;
          this.hasAsanaExpiryData =!!fieldValue;
          break;
        case '10. Total Number of sachets/boxes dispensed (Triphala tablet):':
          this.formData.triphalaDispensedCurrent = fieldValue;
          this.isTriphalaSachetsDisabled=!!fieldValue;
          this.hasTriphalaSDData=!!fieldValue;
          break;
        case '11. Total Study Product quantity dispensed (g) (Triphala tablet):':
          this.formData.triphalaQuantityCurrent = fieldValue;
          this.isTriphalaStudyDisabled=!!fieldValue;
          this.hasTriphalaQData =!!fieldValue;
          break;
        case '12. Batch Number (Triphala tablet):':
          this.formData.triphalaBatch = fieldValue;
          this.isTriphalaBatchDisabled=!!fieldValue;
          this.hasTriphalaBatchData =!!fieldValue;
          break;
        case '13. Date of Expiry (Triphala tablet):':
          this.formData.triphalaExpiry = fieldValue;
          this.isTriphalaExpiryDisabled=!!fieldValue;
          this.hasTriphalaExpiryData =!!fieldValue;
          break;
        case '14. Total Number of sachets/boxes dispensed (Yava Churna):':
          this.formData.yavaDispensedCurrent = fieldValue;
          this.isYavaSachetsDisabled=!!fieldValue;
          this.hasYavaSDData=!!fieldValue;
          break;
        case '15. Total Study Product quantity dispensed (g) (Yava Churna):':
          this.formData.yavaQuantityCurrent = fieldValue;
          this.isYavaStudyDisabled=!!fieldValue;
          this.hasYavaQData=!!fieldValue;
          break;
        case '16. Batch Number (Yava Churna):':
          this.formData.yavaBatch = fieldValue;
          this.isYavaBatchDisabled=!!fieldValue;
          this.hasYavaBatchData=!!fieldValue;
          break;
        case '17. Date of Expiry (Yava Churna):':
          this.formData.yavaExpiry = fieldValue;
          this.isYavaExpiryDisabled=!!fieldValue;
          this.hasYavaExpiryData=!!fieldValue;
          break;
        case 'Did the subject experience any adverse event since last visit':
          this.formData.adverseEvent = fieldValue;
          this.isAdverseDisabled=!!fieldValue;
          this.hasAdverse1Data =!!fieldValue;
          break;
        case 'Did the subject take any new or change in concomitant medications since last visit':
          this.formData.concomitantMedication = fieldValue;
          this.isAdverseDisabled2=!!fieldValue;
          this.hasAdverse2Data =!!fieldValue;
          break;
        default:
          console.warn(`No mapping found for field: ${fieldName}`);
          break;
      }
    });
  }
editStudy() {
  // Open edit reason modal only if field already has a value
  if (this.fieldLabel === '1. Follow Up Visit No:' && this.formData.visitNo) {
    this.isReasonModalOpen = true;
  } 
  else if (this.fieldLabel === '2. Date of Visit:' && this.formData.visitDate ) {
    this.isReasonModalOpen = true;
  } 
    else if (this.fieldLabel === '1. Was Vital Signs evaluation performed') {
    this.isReasonModalOpen = true;
  } 
   else if (this.fieldLabel === '1. Was physical and systematic examination performed') {
    this.isReasonModalOpen = true;
  } 
  else if (this.fieldLabel === '1. Was Laboratory Investigation performed') {
    this.isReasonModalOpen = true;
  } 
  else if (this.fieldLabel === '2. Date of Sample Collection:') {
    this.isReasonModalOpen = true;
  } 
   else if (this.fieldLabel === 'Date of Last Menstrual Period (LMP)') {
    this.isReasonModalOpen = true;
  } 
   else if (this.fieldLabel === 'Was Urine Pregnancy Test (UPT) done') {
    this.isReasonModalOpen = true;
  } 
     else if (this.fieldLabel === 'UPT Result') {
    this.isReasonModalOpen = true;
  } 
     else if (this.fieldLabel === '1. Weight (kg):') {
    this.isReasonModalOpen = true;
  } 
   else if (this.fieldLabel === '2. Height (m):') {
    this.isReasonModalOpen = true;
  } 
   else if (this.fieldLabel === '3. Waist Circumference (cm):') {
    this.isReasonModalOpen = true;
  } 
  else if (this.fieldLabel === 'Was the Study Product retrieved from subject as per protocol') {
    this.isReasonModalOpen = true;
  } 
else if (this.fieldLabel === 'Did the subject experience any adverse event since last visit') {
    this.isReasonModalOpen = true;
  } 
  else if (this.fieldLabel === 'Did the subject take any new or change in concomitant medications since last visit') {
    this.isReasonModalOpen = true;
  } 
   else if (this.fieldLabel === '4. Weight-loss from previous visit (kg):') {
    this.isReasonModalOpen = true;
  } 
    else if (this.fieldLabel === '5. Weight-loss since baseline visit (kg):') {
    this.isReasonModalOpen = true;
  } 
   else if (this.fieldLabel === '6. Difference in Waist circumference from previous visit (cm):') {
    this.isReasonModalOpen = true;
  } 
  else if (this.fieldLabel === '7. Difference in Waist circumference since baseline visit (cm):') {
    this.isReasonModalOpen = true;
  } 
   else if (this.fieldLabel === '8. Body Mass Index (BMI):') {
    this.isReasonModalOpen = true;
  } 
   else if (this.fieldLabel === 'Is the subject compliant with the usage of Study Product as per the protocol (Asana Churna)') {
    this.isReasonModalOpen = true;
  } 
 else if (this.fieldLabel === 'Date of first Study Product consumed (Asana Churna):') {
    this.isReasonModalOpen = true;
  } 
 else if (this.fieldLabel === 'Date of last Study Product consumed (Asana Churna):') {
    this.isReasonModalOpen = true;
  } 
 else if (this.fieldLabel === 'Total quantity of Study Product consumed (g) (Asana Churna):') {
    this.isReasonModalOpen = true;
  } 
else if (this.fieldLabel === 'Total quantity of Study Product should ideally be consumed (g) (Asana Churna):') {
    this.isReasonModalOpen = true;
  } 
  else if (this.fieldLabel === 'Total quantity missed (Asana Churna):') {
    this.isReasonModalOpen = true;
  } 
   else if (this.fieldLabel === 'Compliance (%) (Asana Churna):') {
    this.isReasonModalOpen = true;
  } 
   else if (this.fieldLabel === 'Is the subject compliant with the usage of Study Product as per the protocol (Triphala)') {
    this.isReasonModalOpen = true;
  } 
    else if (this.fieldLabel === 'Date of first Study Product consumed (Triphala):') {
    this.isReasonModalOpen = true;
  } 
 else if (this.fieldLabel === 'Date of last Study Product consumed (Triphala):') {
    this.isReasonModalOpen = true;
  } 
   else if (this.fieldLabel === 'Total quantity of Study Product consumed (g) (Triphala):') {
    this.isReasonModalOpen = true;
  } 
    else if (this.fieldLabel === 'Total quantity of Study Product should ideally be consumed (g) (Triphala):') {
    this.isReasonModalOpen = true;
  } 
    else if (this.fieldLabel === 'Total quantity missed (Triphala):') {
    this.isReasonModalOpen = true;
  } 
   else if (this.fieldLabel === 'Compliance (%) (Triphala):') {
    this.isReasonModalOpen = true;
  } 
    else if (this.fieldLabel === 'Is the subject compliant with the usage of Study Product as per the protocol (Yava Churna)') {
    this.isReasonModalOpen = true;
  }
   else if (this.fieldLabel === 'Date of first Study Product consumed (Yava Churna):') {
    this.isReasonModalOpen = true;
  }
   else if (this.fieldLabel === 'Date of last Study Product consumed (Yava Churna):') {
    this.isReasonModalOpen = true;
  }
    else if (this.fieldLabel === 'Total quantity of Study Product consumed (g) (Yava Churna):') {
    this.isReasonModalOpen = true;
  }
   else if (this.fieldLabel === 'Total quantity of Study Product should ideally be consumed (g) (Yava Churna):') {
    this.isReasonModalOpen = true;
  }
 else if (this.fieldLabel === 'Total quantity missed (Yava Churna):') {
    this.isReasonModalOpen = true;
  }
   else if (this.fieldLabel === 'Compliance (%) (Yava Churna):') {
    this.isReasonModalOpen = true;
  }
   else if (this.fieldLabel === 'Total Number of sachets/boxes dispensed in previous visit (Asana Churna herbal drink):') {
    this.isReasonModalOpen = true;
  }
    else if (this.fieldLabel === 'Total Study Product quantity dispensed in previous visit (g) (Asana Churna herbal drink):') {
    this.isReasonModalOpen = true;
  }
 else if (this.fieldLabel === 'Total Number of sachets/boxes retrieved in current visit (Asana Churna herbal drink):') {
    this.isReasonModalOpen = true;
  }
 else if (this.fieldLabel === 'Total Number of sachets/boxes dispensed in previous visit (Triphala tablet):') {
    this.isReasonModalOpen = true;
  }
   else if (this.fieldLabel === 'Total Study Product quantity dispensed in previous visit (g) (Triphala tablet):') {
    this.isReasonModalOpen = true;
  }
  else if (this.fieldLabel === 'Total Number of sachets/boxes retrieved in current visit (Triphala tablet):') {
    this.isReasonModalOpen = true;
  }
    else if (this.fieldLabel === 'Total Number of sachets/boxes dispensed in previous visit (Yava Churna):') {
    this.isReasonModalOpen = true;
  }
  else if (this.fieldLabel === 'Total Study Product quantity dispensed in previous visit (g) (Yava Churna):') {
    this.isReasonModalOpen = true;
  }
   else if (this.fieldLabel === 'Total Number of sachets/boxes retrieved in current visit (Yava Churna):') {
    this.isReasonModalOpen = true;
  }
 else if (this.fieldLabel === '1. Were all the Study Products dispensed to the subject as per protocol') {
    this.isReasonModalOpen = true;
  }
else if (this.fieldLabel === '3. Was the Daily Product Consumption Log given to the subject') {
    this.isReasonModalOpen = true;
  }
else if (this.fieldLabel === '5. Date of dispensing of the Study Products:') {
    this.isReasonModalOpen = true;
  }
  else if (this.fieldLabel === '6. Total Number of sachets/boxes dispensed (Asana Churna herbal drink):') {
    this.isReasonModalOpen = true;
  }
  else if (this.fieldLabel === '7. Total Study Product quantity dispensed (g) (Asana Churna herbal drink):') {
    this.isReasonModalOpen = true;
  }
 else if (this.fieldLabel === '8. Batch Number (Asana Churna herbal drink):') {
    this.isReasonModalOpen = true;
  }
  else if (this.fieldLabel === '9. Date of Expiry (Asana Churna herbal drink):') {
    this.isReasonModalOpen = true;
  }
   else if (this.fieldLabel === '10. Total Number of sachets/boxes dispensed (Triphala tablet):') {
    this.isReasonModalOpen = true;
  }
 else if (this.fieldLabel === '11. Total Study Product quantity dispensed (g) (Triphala tablet):') {
    this.isReasonModalOpen = true;
  }
 else if (this.fieldLabel === '12. Batch Number (Triphala tablet):') {
    this.isReasonModalOpen = true;
  }
 else if (this.fieldLabel === '13. Date of Expiry (Triphala tablet):') {
    this.isReasonModalOpen = true;
  }
 else if (this.fieldLabel === '14. Total Number of sachets/boxes dispensed (Yava Churna):') {
    this.isReasonModalOpen = true;
  }
else if (this.fieldLabel === '15. Total Study Product quantity dispensed (g) (Yava Churna):') {
    this.isReasonModalOpen = true;
  }
else if (this.fieldLabel === '16. Batch Number (Yava Churna):') {
    this.isReasonModalOpen = true;
  }
  else if (this.fieldLabel === '17. Date of Expiry (Yava Churna):') {
    this.isReasonModalOpen = true;
  }

  
  
  else {
    // First time - no need to ask
   if (this.fieldLabel === '1. Follow Up Visit No:' ) {
    this.isVisitNoDisabled=false;
  } 
   else if (this.fieldLabel === '2. Date of Visit:' ) {
    this.isDateOfVisitDisabled = false;
  } 
    else if (this.fieldLabel === '1. Was Vital Signs evaluation performed') {
    this.isVitalSignDisabled = false;
  } 
 else if (this.fieldLabel === '1. Was physical and systematic examination performed') {
    this.isPhysicalExamDisabled=false;
  } 
 else if (this.fieldLabel === '1. Was Laboratory Investigation performed') {
    this.isLabDisabled=false;
  } 
  else if (this.fieldLabel === '2. Date of Sample Collection:') {
    this.isDateofSampleDisabled=false;
  }
 else if (this.fieldLabel === 'Date of Last Menstrual Period (LMP)') {
    this.isLMPDateDisabled=false;
  }
    else if (this.fieldLabel === 'Was Urine Pregnancy Test (UPT) done') {
    this.isUPTDoneDisabled=false;
  } 
  else if (this.fieldLabel === 'UPT Result') {
    this.isUPTResultDisabled=false;
  } 
   else if (this.fieldLabel === '1. Weight (kg):') {
    this.isWeightDisabled=false;
  } 
  else if (this.fieldLabel === '2. Height (m):') {
    this.isHeightDisabled=false;
  } 
   else if (this.fieldLabel === '3. Waist Circumference (cm):') {
    this.isWaistDisabled=false;
  } 
 else if (this.fieldLabel === 'Was the Study Product retrieved from subject as per protocol') {
    this.isRetrievedDisabled = false;
  } 
else if (this.fieldLabel === 'Did the subject experience any adverse event since last visit') {
    this.isAdverseDisabled=false;
  } 
 else if (this.fieldLabel === 'Did the subject take any new or change in concomitant medications since last visit') {
    this.isAdverseDisabled2=false;
  } 
   else if (this.fieldLabel === '4. Weight-loss from previous visit (kg):') {
    this.isWeightLossPreviousDisabled=false;
  } 
   else if (this.fieldLabel === '5. Weight-loss since baseline visit (kg):') {
    this.isWeightLossBaselineDisabled=false;
  } 
    else if (this.fieldLabel === '6. Difference in Waist circumference from previous visit (cm):') {
    this.isWaistDifferencePreviousDisabled=false;
  } 
 else if (this.fieldLabel === '7. Difference in Waist circumference since baseline visit (cm):') {
    this.isWaistDifferenceBaselineDisabled=false;
  } 
   else if (this.fieldLabel === '8. Body Mass Index (BMI):') {
    this.isBMIDisabled=false;
  }
else if (this.fieldLabel === 'Is the subject compliant with the usage of Study Product as per the protocol (Asana Churna)') {
    this.isStudyComplainceDisabled=false;
  } 
   else if (this.fieldLabel === 'Date of first Study Product consumed (Asana Churna):') {
    this.isAsanaFirstDateDisabled=false;
  } 
else if (this.fieldLabel === 'Date of last Study Product consumed (Asana Churna):') {
    this.isAsanaLastDateDisabled=false;
  } 
   else if (this.fieldLabel === 'Total quantity of Study Product consumed (g) (Asana Churna):') {
    this.isAsanaConsumedDisabled=false;
  } 
else if (this.fieldLabel === 'Total quantity of Study Product should ideally be consumed (g) (Asana Churna):') {
    this.isAsanaIdealDisabled=false;
  } 
 else if (this.fieldLabel === 'Total quantity missed (Asana Churna):') {
    this.isAsanaMissedDisabled=false;
  } 
    else if (this.fieldLabel === 'Compliance (%) (Asana Churna):') {
    this.isAsanaPercentageDisabled=false;
  } 
   else if (this.fieldLabel === 'Is the subject compliant with the usage of Study Product as per the protocol (Triphala)') {
    this.isTriphalaComplianceDisabled=false;
  } 
    else if (this.fieldLabel === 'Date of first Study Product consumed (Triphala):') {
    this.isTriphalaFirstDateDisabled=false;
  } 
 else if (this.fieldLabel === 'Date of last Study Product consumed (Triphala):') {
    this.isTriphalaLastDateDisabled=false;
  } 
  else if (this.fieldLabel === 'Total quantity of Study Product consumed (g) (Triphala):') {
    this.isTriphalaConsumedDisabled=false;
  } 
   else if (this.fieldLabel === 'Total quantity of Study Product should ideally be consumed (g) (Triphala):') {
    this.isTriphalaIdealDisabled=false;
  } 
    else if (this.fieldLabel === 'Total quantity missed (Triphala):') {
    this.isTriphalaMissedDisabled=false;
  }
    else if (this.fieldLabel === 'Compliance (%) (Triphala):') {
    this.isTriphalaPercentageDisabled=false;
  } 
 else if (this.fieldLabel === 'Is the subject compliant with the usage of Study Product as per the protocol (Yava Churna)') {
    this.isYavaComplianceDisabled=false;
  }
    else if (this.fieldLabel === 'Date of first Study Product consumed (Yava Churna):') {
    this.isYavaFirstDateDisabled=false;
  }
     else if (this.fieldLabel === 'Date of last Study Product consumed (Yava Churna):') {
    this.isYavaLastDateDisabled=false;
  }
  else if (this.fieldLabel === 'Total quantity of Study Product consumed (g) (Yava Churna):') {
    this.isYavaConsumedDisabled=false;
  }
    else if (this.fieldLabel === 'Total quantity of Study Product should ideally be consumed (g) (Yava Churna):') {
    this.isYavaIdealDisabled=false;
  }
   else if (this.fieldLabel === 'Total quantity missed (Yava Churna):') {
    this.isYavaMissedDisabled=false;
  }
  else if (this.fieldLabel === 'Compliance (%) (Yava Churna):') {
    this.isYavaPercentageDisabled=false;
  }
 else if (this.fieldLabel === 'Total Number of sachets/boxes dispensed in previous visit (Asana Churna herbal drink):') {
    this.isAsanaDispensedDisabled=false;
  }
   else if (this.fieldLabel === 'Total Study Product quantity dispensed in previous visit (g) (Asana Churna herbal drink):') {
    this.isAsanaQuantityDisabled=false;
  }
   else if (this.fieldLabel === 'Total Number of sachets/boxes retrieved in current visit (Asana Churna herbal drink):') {
    this.isAsanaRetrievedDisabled=false;
  }
 else if (this.fieldLabel === 'Total Number of sachets/boxes dispensed in previous visit (Triphala tablet):') {
    this.isTriphalaDispensedDisabled=false;
  }
  else if (this.fieldLabel === 'Total Study Product quantity dispensed in previous visit (g) (Triphala tablet):') {
    this.isTriphalaQuantityDisabled=false;
  }
   else if (this.fieldLabel === 'Total Number of sachets/boxes retrieved in current visit (Triphala tablet):') {
    this.isTriphalaRetrievedDisabled=false;
  }
    else if (this.fieldLabel === 'Total Number of sachets/boxes dispensed in previous visit (Yava Churna):') {
    this.isYavaDispensedDisabled=false;
  }
   else if (this.fieldLabel === 'Total Study Product quantity dispensed in previous visit (g) (Yava Churna):') {
    this.isYavaQuantityDisabled=false;
  }
   else if (this.fieldLabel === 'Total Number of sachets/boxes retrieved in current visit (Yava Churna):') {
    this.isYavaRetrievedDisabled=false;
  }
else if (this.fieldLabel === '1. Were all the Study Products dispensed to the subject as per protocol') {
    this.isDispensedProtocolDisabled=false;
  }
  else if (this.fieldLabel === '3. Was the Daily Product Consumption Log given to the subject') {
    this.isLogGivenDisabled=false;
  }
else if (this.fieldLabel === '5. Date of dispensing of the Study Products:') {
    this.isDispensingDateDisabled=false;
  }
  else if (this.fieldLabel === '6. Total Number of sachets/boxes dispensed (Asana Churna herbal drink):') {
    this.isAsanaSachetsDisabled=false;
  }
 else if (this.fieldLabel === '7. Total Study Product quantity dispensed (g) (Asana Churna herbal drink):') {
    this.isAsanaStudyDisabled=false;
  }
  else if (this.fieldLabel === '8. Batch Number (Asana Churna herbal drink):') {
    this.isAsanaBatchDisabled=false;
  }
else if (this.fieldLabel === '9. Date of Expiry (Asana Churna herbal drink):') {
    this.isAsanaExpiryDisabled=false;
  }
  else if (this.fieldLabel === '10. Total Number of sachets/boxes dispensed (Triphala tablet):') {
    this.isTriphalaSachetsDisabled=false;
  }
 else if (this.fieldLabel === '11. Total Study Product quantity dispensed (g) (Triphala tablet):') {
    this.isTriphalaStudyDisabled=false;
  }
   else if (this.fieldLabel === '12. Batch Number (Triphala tablet):') {
    this.isTriphalaBatchDisabled=false;
  }
else if (this.fieldLabel === '13. Date of Expiry (Triphala tablet):') {
    this.isTriphalaExpiryDisabled=false;
  }
 else if (this.fieldLabel === '14. Total Number of sachets/boxes dispensed (Yava Churna):') {
    this.isYavaSachetsDisabled=false;
  }
else if (this.fieldLabel === '15. Total Study Product quantity dispensed (g) (Yava Churna):') {
    this.isYavaStudyDisabled=false;
  }
else if (this.fieldLabel === '16. Batch Number (Yava Churna):') {
    this.isYavaBatchDisabled=false;
  }
  else if (this.fieldLabel === '17. Date of Expiry (Yava Churna):') {
    this.isYavaExpiryDisabled=false;
  }




  

  }
}
confirmEditReason() {
  if (!this.editReason.trim()) {
    alert('Please enter a reason before proceeding.');
    return;
  }

  if (this.fieldLabel === '1. Follow Up Visit No:' ) {
    this.isVisitNoDisabled=false;
  } 
   else if (this.fieldLabel === '2. Date of Visit:' ) {
    this.isDateOfVisitDisabled = false;
  } 
    else if (this.fieldLabel === '1. Was Vital Signs evaluation performed') {
    this.isVitalSignDisabled = false;
  } 
   else if (this.fieldLabel === '1. Was physical and systematic examination performed') {
    this.isPhysicalExamDisabled=false;
  } 
  else if (this.fieldLabel === '1. Was Laboratory Investigation performed') {
    this.isLabDisabled=false;
  } 
   else if (this.fieldLabel === '2. Date of Sample Collection:') {
    this.isDateofSampleDisabled=false;
  }
 else if (this.fieldLabel === 'Date of Last Menstrual Period (LMP)') {
    this.isLMPDateDisabled=false;
  }
  else if (this.fieldLabel === 'Was Urine Pregnancy Test (UPT) done') {
    this.isUPTDoneDisabled=false;
  } 
 else if (this.fieldLabel === 'UPT Result') {
    this.isUPTResultDisabled=false;
  } 
else if (this.fieldLabel === '1. Weight (kg):') {
    this.isWeightDisabled=false;
  } 
 else if (this.fieldLabel === '2. Height (m):') {
    this.isHeightDisabled=false;
  } 
  else if (this.fieldLabel === '3. Waist Circumference (cm):') {
    this.isWaistDisabled=false;
  } 
else if (this.fieldLabel === 'Was the Study Product retrieved from subject as per protocol') {
    this.isRetrievedDisabled=false;
  } 
  else if (this.fieldLabel === 'Did the subject experience any adverse event since last visit') {
    this.isAdverseDisabled=false;
  } 
   else if (this.fieldLabel === 'Did the subject take any new or change in concomitant medications since last visit') {
    this.isAdverseDisabled2=false;
  } 
    else if (this.fieldLabel === '4. Weight-loss from previous visit (kg):') {
    this.isWeightLossPreviousDisabled=false;
  } 
  else if (this.fieldLabel === '5. Weight-loss since baseline visit (kg):') {
    this.isWeightLossBaselineDisabled=false;
  } 
   else if (this.fieldLabel === '6. Difference in Waist circumference from previous visit (cm):') {
    this.isWaistDifferencePreviousDisabled=false;
  } 
   else if (this.fieldLabel === '7. Difference in Waist circumference since baseline visit (cm):') {
    this.isWaistDifferenceBaselineDisabled=false;
  } 
  else if (this.fieldLabel === '8. Body Mass Index (BMI):') {
    this.isBMIDisabled=false;
  }
else if (this.fieldLabel === 'Is the subject compliant with the usage of Study Product as per the protocol (Asana Churna)') {
    this.isStudyComplainceDisabled=false;
  } 
   else if (this.fieldLabel === 'Date of first Study Product consumed (Asana Churna):') {
    this.isAsanaFirstDateDisabled=false;
  } 
else if (this.fieldLabel === 'Date of last Study Product consumed (Asana Churna):') {
    this.isAsanaLastDateDisabled=false;
  } 
    else if (this.fieldLabel === 'Total quantity of Study Product consumed (g) (Asana Churna):') {
    this.isAsanaConsumedDisabled=false;
  }
  else if (this.fieldLabel === 'Total quantity of Study Product should ideally be consumed (g) (Asana Churna):') {
    this.isAsanaIdealDisabled=false;
  } 
   else if (this.fieldLabel === 'Total quantity missed (Asana Churna):') {
    this.isAsanaMissedDisabled=false;
  } 
   else if (this.fieldLabel === 'Compliance (%) (Asana Churna):') {
    this.isAsanaPercentageDisabled=false;
  }
 else if (this.fieldLabel === 'Is the subject compliant with the usage of Study Product as per the protocol (Triphala)') {
    this.isTriphalaComplianceDisabled=false;
  } 
   else if (this.fieldLabel === 'Date of first Study Product consumed (Triphala):') {
    this.isTriphalaFirstDateDisabled=false;
  } 
 else if (this.fieldLabel === 'Date of last Study Product consumed (Triphala):') {
    this.isTriphalaLastDateDisabled=false;
  } 
  else if (this.fieldLabel === 'Total quantity of Study Product consumed (g) (Triphala):') {
    this.isTriphalaConsumedDisabled=false;
  } 
 else if (this.fieldLabel === 'Total quantity of Study Product should ideally be consumed (g) (Triphala):') {
    this.isTriphalaIdealDisabled=false;
  } 
    else if (this.fieldLabel === 'Total quantity missed (Triphala):') {
    this.isTriphalaMissedDisabled=false;
  }
   else if (this.fieldLabel === 'Compliance (%) (Triphala):') {
    this.isTriphalaPercentageDisabled=false;
  } 
 else if (this.fieldLabel === 'Is the subject compliant with the usage of Study Product as per the protocol (Yava Churna)') {
    this.isYavaComplianceDisabled=false;
  }
 else if (this.fieldLabel === 'Date of first Study Product consumed (Yava Churna):') {
    this.isYavaFirstDateDisabled=false;
  }
 else if (this.fieldLabel === 'Date of last Study Product consumed (Yava Churna):') {
    this.isYavaLastDateDisabled=false;
  }
 else if (this.fieldLabel === 'Total quantity of Study Product consumed (g) (Yava Churna):') {
    this.isYavaConsumedDisabled=false;
  }
  else if (this.fieldLabel === 'Total quantity of Study Product should ideally be consumed (g) (Yava Churna):') {
    this.isYavaIdealDisabled=false;
  }
   else if (this.fieldLabel === 'Total quantity missed (Yava Churna):') {
    this.isYavaMissedDisabled=false;
  }
   else if (this.fieldLabel === 'Compliance (%) (Yava Churna):') {
    this.isYavaPercentageDisabled=false;
  }
 else if (this.fieldLabel === 'Total Number of sachets/boxes dispensed in previous visit (Asana Churna herbal drink):') {
    this.isAsanaDispensedDisabled=false;
  }
   else if (this.fieldLabel === 'Total Study Product quantity dispensed in previous visit (g) (Asana Churna herbal drink):') {
    this.isAsanaQuantityDisabled=false;
  }
   else if (this.fieldLabel === 'Total Number of sachets/boxes retrieved in current visit (Asana Churna herbal drink):') {
    this.isAsanaRetrievedDisabled=false;
  }
  else if (this.fieldLabel === 'Total Number of sachets/boxes dispensed in previous visit (Triphala tablet):') {
    this.isTriphalaDispensedDisabled=false;
  }
   else if (this.fieldLabel === 'Total Study Product quantity dispensed in previous visit (g) (Triphala tablet):') {
    this.isTriphalaQuantityDisabled=false;
  }
 else if (this.fieldLabel === 'Total Number of sachets/boxes retrieved in current visit (Triphala tablet):') {
    this.isTriphalaRetrievedDisabled=false;
  }
    else if (this.fieldLabel === 'Total Number of sachets/boxes dispensed in previous visit (Yava Churna):') {
    this.isYavaDispensedDisabled=false;
  }
   else if (this.fieldLabel === 'Total Study Product quantity dispensed in previous visit (g) (Yava Churna):') {
    this.isYavaQuantityDisabled=false;
  }
  else if (this.fieldLabel === 'Total Number of sachets/boxes retrieved in current visit (Yava Churna):') {
    this.isYavaRetrievedDisabled=false;
  }
  else if (this.fieldLabel === '1. Were all the Study Products dispensed to the subject as per protocol') {
    this.isDispensedProtocolDisabled=false;
  }
 else if (this.fieldLabel === '3. Was the Daily Product Consumption Log given to the subject') {
    this.isLogGivenDisabled=false;
  }
  else if (this.fieldLabel === '5. Date of dispensing of the Study Products:') {
    this.isDispensingDateDisabled=false;
  }
   else if (this.fieldLabel === '6. Total Number of sachets/boxes dispensed (Asana Churna herbal drink):') {
    this.isAsanaSachetsDisabled=false;
  }
else if (this.fieldLabel === '7. Total Study Product quantity dispensed (g) (Asana Churna herbal drink):') {
    this.isAsanaStudyDisabled=false;
  }
   else if (this.fieldLabel === '8. Batch Number (Asana Churna herbal drink):') {
    this.isAsanaBatchDisabled=false;
  }
else if (this.fieldLabel === '9. Date of Expiry (Asana Churna herbal drink):') {
    this.isAsanaExpiryDisabled=false;
  }
 else if (this.fieldLabel === '10. Total Number of sachets/boxes dispensed (Triphala tablet):') {
    this.isTriphalaSachetsDisabled=false;
  }
 else if (this.fieldLabel === '11. Total Study Product quantity dispensed (g) (Triphala tablet):') {
    this.isTriphalaStudyDisabled=false;
  }
  else if (this.fieldLabel === '12. Batch Number (Triphala tablet):') {
    this.isTriphalaBatchDisabled=false;
  }
else if (this.fieldLabel === '13. Date of Expiry (Triphala tablet):') {
    this.isTriphalaExpiryDisabled=false;
  }
 else if (this.fieldLabel === '14. Total Number of sachets/boxes dispensed (Yava Churna):') {
    this.isYavaSachetsDisabled=false;
  }
else if (this.fieldLabel === '15. Total Study Product quantity dispensed (g) (Yava Churna):') {
    this.isYavaStudyDisabled=false;
  }
else if (this.fieldLabel === '16. Batch Number (Yava Churna):') {
    this.isYavaBatchDisabled=false;
  }
  else if (this.fieldLabel === '17. Date of Expiry (Yava Churna):') {
    this.isYavaExpiryDisabled=false;
  }








  
  
  
  this.isReasonModalOpen = false;
}
cancelEditReason() {
  this.isReasonModalOpen = false;
  this.editReason = '';
}
formatTimeTo24Hour(time: string): string {
    const [hours, minutes] = time.split(':');
    return `${hours}:${minutes}`; // Ensures it's always in 24-hour format
}

  toggleComments(elementId: string, show: boolean): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.style.display = show ? 'block' : 'none';
    }
  }
  handleUptResultChange(): void {
    if (this.formData.uptResult === 'Positive') {
      alert('As the UPT test is positive, kindly exclude the patient from the study.');
    }
  }
  
  navigateToConcomitantMedication(): void {
    if (this.studyId && this.subjectId) {
      this.router.navigate(['/folders/concomitant-medication/concomitant-medication-log'], {
        queryParams: { studyId: this.studyId, subjectId: this.subjectId }
      });
    } else {
      console.error('Missing studyId or subjectId');
    }
  }
  navigateToVitalSigns(): void {
    if (this.studyId && this.subjectId) {
      this.router.navigate(['/folders/vital-signs/vital-signs'], {
        queryParams: { studyId: this.studyId, subjectId: this.subjectId }
      });
    } else {
      console.error('Missing studyId or subjectId');
    }
  }
  navigateToAdverseEvents(): void {
    if (this.studyId && this.subjectId) {
      this.router.navigate(['/folders/adverse-events/adverse-event-report'], {
        queryParams: { studyId: this.studyId, subjectId: this.subjectId }
      });
    } else {
      console.error('Missing studyId or subjectId');
    }
  }
  navigateToLaboratory(): void {
    if (this.studyId && this.subjectId) {
      this.router.navigate(['/folders/laboratory-investigation-log/laboratory-investigation-log'], {
        queryParams: { studyId: this.studyId, subjectId: this.subjectId }
      });
    } else {
      console.error('Missing studyId or subjectId');
    }
  }
  
  
  
  navigateToPhysicalSystemic(): void {
    if (this.studyId && this.subjectId) {
      this.router.navigate(['/folders/physical-systemic/physical-systemic'], {
        queryParams: { studyId: this.studyId, subjectId: this.subjectId }
      });
    } else {
      console.error('Missing studyId or subjectId');
    }
}

  
  
  calculateCompliance(section: string): void {
    const consumed = parseFloat((document.getElementById(`${section}Consumed`) as HTMLInputElement).value);
    const idealConsumed = parseFloat((document.getElementById(`${section}IdealConsumed`) as HTMLInputElement).value);

    if (!isNaN(consumed) && !isNaN(idealConsumed) && idealConsumed !== 0) {
      const compliancePercentage = (consumed / idealConsumed) * 100;
      (document.getElementById(`${section}CompliancePercentage`) as HTMLInputElement).value =
        compliancePercentage.toFixed(2) + '%';
      this.formData[`${section}CompliancePercentage`] = compliancePercentage.toFixed(2);
    } else {
      (document.getElementById(`${section}CompliancePercentage`) as HTMLInputElement).value = '';
      this.formData[`${section}CompliancePercentage`] = null;
    }
  }
  validateForm() {
    const weightPattern = /^\d{3}\.\d{2}$/;
    const heightPattern = /^\d{2}\.\d{2}$/;
    const waistPattern = /^\d{3}\.\d{2}$/;
    const  weightLossPreviousPattern= /^\d{3}\.\d{2}$/;
    const  weightLossBaselinePattern= /^\d{3}\.\d{2}$/;
    const   waistDifferencePreviousPattern= /^\d{3}\.\d{2}$/;
    const waistDifferenceBaselinePattern= /^\d{3}\.\d{2}$/;
    const asanaQuantityPreviousPattern = /^\d{3}$/;  // 3 digits followed by 'g'
  const triphalaQuantityPreviousPattern = /^\d{3}$/;  // 3 digits followed by 'g'
  const yavaQuantityPreviousPattern = /^\d{3}$/;  // 3 digits followed by 'g'
  const asanaIdealConsumedPattern = /^\d{3}$/; 
  const asanaConsumedPattern = /^\d{3}$/;
  const triphalaConsumedPattern = /^\d{3}$/;
  const triphalaIdealConsumedPattern = /^\d{3}$/;
  const yavaConsumedPattern = /^\d{3}$/;
  const yavaIdealConsumedPattern = /^\d{3}$/;
  const asanaQuantityCurrentPattern = /^\d{3}$/;
  const triphalaQuantityCurrentPattern = /^\d{3}$/;
  const yavaQuantityCurrentPattern = /^\d{3}$/;
  

    const { weight, height, waistCircumference,waistDifferenceBaseline,waistDifferencePrevious,weightLossBaseline, weightLossPrevious,asanaQuantityPrevious,triphalaQuantityPrevious,yavaQuantityPrevious,asanaIdealConsumed,asanaConsumed,triphalaConsumed,triphalaIdealConsumed,yavaConsumed,yavaIdealConsumed,asanaQuantityCurrent,triphalaQuantityCurrent,yavaQuantityCurrent } = this.formData;
    
    // Only validate fields if they are not empty
    if (weight && !weightPattern.test(weight)) {
      alert("Invalid weight format. Please enter in 000.00 kg format.");
      return;
    }
  
    if (height && !heightPattern.test(height)) {
      alert("Invalid height format. Please enter in 00.00 m format.");
      return;
    }
  
    if (waistCircumference && !waistPattern.test(waistCircumference)) {
      alert("Invalid waist circumference format. Please enter in 000.00 cm format.");
      return;
    }
    if (weightLossPrevious && !weightLossPreviousPattern.test(weightLossPrevious)) {
      alert("Invalid weightLossPrevious format. Please enter in 000.00 kg format.");
      return;
    }
  
    if (weightLossBaseline && !weightLossBaselinePattern.test(weightLossBaseline)) {
      alert("Invalid weightLossBaseline format. Please enter in 000.00 kg format.");
      return;
    }
  
    if (waistDifferencePrevious && !waistDifferencePreviousPattern.test(waistDifferencePrevious)) {
      alert("Invalid waistDifferencePrevious format. Please enter in 000.00 cm format.");
      return;
    }
  
    if (waistDifferenceBaseline && !waistDifferenceBaselinePattern.test(waistDifferenceBaseline)) {
      alert("Invalid waistDifferenceBaseline format. Please enter in 000.00 cm format.");
      return;
    }
    // Validate the new asanaChurnaQuantity field using this.formData
  if (asanaQuantityPrevious && !asanaQuantityPreviousPattern.test(asanaQuantityPrevious)) {
    alert("Invalid asanaQuantityPrevious format. Please enter in 123g format (3 digits).");
    return;
  }
   // Validate the new asanaChurnaQuantity field using this.formData
   if (triphalaQuantityPrevious && !triphalaQuantityPreviousPattern.test(triphalaQuantityPrevious)) {
    alert("Invalid triphalaQuantityPrevious format. Please enter in 123g format (3 digits).");
    return;
  }
   // Validate the new asanaChurnaQuantity field using this.formData
   if (yavaQuantityPrevious && !yavaQuantityPreviousPattern.test(yavaQuantityPrevious)) {
    alert("Invalid yavaQuantityPrevious  format. Please enter in 123g format (3 digits).");
    return;
  }
  // Validate the new asanaChurnaQuantity field using this.formData
  if (asanaIdealConsumed && !asanaIdealConsumedPattern.test(asanaIdealConsumed)) {
    alert("Invalid asanaIdealConsumed  format. Please enter in 123g format (3 digits).");
    return;
  }
  // Validate the new asanaChurnaQuantity field using this.formData
  if (asanaConsumed && !asanaConsumedPattern.test(asanaConsumed)) {
    alert("Invalid asanaConsumed  format. Please enter in 123g format (3 digits).");
    return;
  }
  // Validate the new asanaChurnaQuantity field using this.formData
  if (triphalaConsumed && !triphalaConsumedPattern.test(triphalaConsumed)) {
    alert("Invalid triphalaConsumed  format. Please enter in 123g format (3 digits).");
    return;
  }
  // Validate the new asanaChurnaQuantity field using this.formData
  if (triphalaIdealConsumed && !triphalaIdealConsumedPattern.test(triphalaIdealConsumed)) {
    alert("Invalid yavaChurnaQuantity  format. Please enter in 123g format (3 digits).");
    return;
  }
  
  // Validate the new asanaChurnaQuantity field using this.formData
  if (yavaConsumed && !yavaConsumedPattern.test(yavaConsumed)) {
    alert("Invalid yavaConsumed  format. Please enter in 123g format (3 digits).");
    return;
  }
  // Validate the new asanaChurnaQuantity field using this.formData
  if (yavaIdealConsumed && !yavaIdealConsumedPattern.test(yavaIdealConsumed)) {
    alert("Invalid yavaIdealConsumed  format. Please enter in 123g format (3 digits).");
    return;
  }
  // Validate the new asanaChurnaQuantity field using this.formData
  if (asanaQuantityCurrent && !asanaQuantityCurrentPattern.test(asanaQuantityCurrent)) {
    alert("Invalid asanaQuantityCurrent  format. Please enter in 123g format (3 digits).");
    return;
  }
  // Validate the new asanaChurnaQuantity field using this.formData
  if (triphalaQuantityCurrent && !triphalaQuantityCurrentPattern.test(triphalaQuantityCurrent)) {
    alert("Invalid triphalaQuantityCurrent  format. Please enter in 123g format (3 digits).");
    return;
  }
  // Validate the new asanaChurnaQuantity field using this.formData
  if (yavaQuantityCurrent && !yavaQuantityCurrentPattern.test(yavaQuantityCurrent)) {
    alert("Invalid yavaQuantityCurrent  format. Please enter in 123g format (3 digits).");
    return;
  }
  
    // If all are valid, submit the form
    this.submitForm();
  }
  validateVisitNo() {
    if (this.formData.visitNo < 0) {
      this.showError = true;
      this.formData.visitNo = 0;
    } else {
      this.showError = false;
    }
  }
  submitForm() {
    let questionAnswers: { [key: string]: any } = {};

    if (this.formName && this.questionMapping[this.formName]) {
      this.questionMapping[this.formName].forEach(mapping => {
        let fieldKey = mapping.question; // Use question text as key

        if (this.formName === 'follow-up-vital-signs') {
          if (mapping.field === 'vitalSigns' && this.formData.vitalSigns === 'no') {
            questionAnswers[fieldKey] = {
              answer: "no",
               editReason: this.editReason || "",
              value: this.formData.vitalSignsComments
            };
          } else {
            questionAnswers[fieldKey] = this.formData[mapping.field];
          }
        } else if (this.formName === 'follow-up-physical') {
          if (mapping.field === 'physicalExam' && this.formData.physicalExam === 'no') {
            questionAnswers[fieldKey] = {
              answer: "no",
               editReason: this.editReason || "",
              value: this.formData.physicalExamComments
            };
          } else {
            questionAnswers[fieldKey] = this.formData[mapping.field];
          }
        } else if (this.formName === 'follow-up-laboratory-investigation') {
          if (mapping.field === 'labInvestigation' && this.formData.labInvestigation === 'no') {
            questionAnswers[fieldKey] = {
              answer: "no",
               editReason: this.editReason || "",
              value: this.formData.labInvestigationComments
            };
          } else {
            questionAnswers[fieldKey] = this.formData[mapping.field];
          }
        } else if (this.formName === 'follow-up-product-retrieval') {
          if (mapping.field === 'productRetrieved' && this.formData.productRetrieved === 'no') {
            questionAnswers[fieldKey] = {
              answer: "no",
              editReason: this.editReason || "",
              value: this.formData.studyComments
            };
          } else {
            questionAnswers[fieldKey] = this.formData[mapping.field];
          }
        } else if (this.formName === 'follow-up-product-compliance') {
          if (mapping.field === 'asanaCompliance' && this.formData.asanaCompliance === 'no') {
            questionAnswers[fieldKey] = {
              answer: "no",
              editReason: this.editReason || "",
              value: this.formData.studyComplianceComments
            };
          } else if (mapping.field === 'triphalaCompliance' && this.formData.triphalaCompliance === 'no') {
            questionAnswers[fieldKey] = {
              answer: "no",
              editReason: this.editReason || "",
              value: this.formData.triphalaComplianceComments
            };
          } else if (mapping.field === 'yavaCompliance' && this.formData.yavaCompliance === 'no') {
            questionAnswers[fieldKey] = {
              answer: "no",
              editReason: this.editReason || "",
              value: this.formData.yavaComplianceComments
            };
          } else {
            questionAnswers[fieldKey] = this.formData[mapping.field];
          }
        } else if (this.formName === 'follow-up-product-dispensing-record') {
          if (mapping.field === 'dispensedProtocol' && this.formData.dispensedProtocol === 'no') {
            questionAnswers[fieldKey] = {
              answer: "no",
              editReason: this.editReason || "",
              value: this.formData.dispensedProtocolComments
            };
          } else if (mapping.field === 'logGiven' && this.formData.logGiven === 'no') {
            questionAnswers[fieldKey] = {
              answer: "no",
              editReason: this.editReason || "",
              value: this.formData.logGivenComments
            };
          } else {
            questionAnswers[fieldKey] = this.formData[mapping.field];
          }
        } else {
          questionAnswers[fieldKey] = this.formData[mapping.field];
        }
      });
    }

    const submittedData = {
      folderName: "follow-up-visit",
      formName: this.formName,
      studyId: this.studyId,
      subjectId: this.subjectId,
      ...questionAnswers
    };

    console.log("Form Submitted:", submittedData);

    this.apiService.insertFormData(submittedData).subscribe({
      next: (response) => {
        console.log("Response from API:", response);
        alert("Form Submitted Successfully!");

        this.isVisitNoDisabled=true;
        this.isDateOfVisitDisabled=true;
this.isVitalSignDisabled=true;
this.isPhysicalExamDisabled=true;
this.isLabDisabled=true;
this.isDateofSampleDisabled=true;
this.isLMPDateDisabled=true;
this.isUPTDoneDisabled=true;
this.isUPTResultDisabled=true;
this.isWeightDisabled=true;
this.isHeightDisabled=true;
this.isWaistDisabled=true;
this.isRetrievedDisabled=true;
this.isAdverseDisabled=true;
this.isAdverseDisabled2=true;
this.isWeightLossPreviousDisabled=true;
this.isWeightLossBaselineDisabled=true;
this.isWaistDifferencePreviousDisabled=true;
this.isWaistDifferenceBaselineDisabled=true;
this.isBMIDisabled=true;
this.isStudyComplainceDisabled=true;
this.isAsanaFirstDateDisabled=true;
this.isAsanaLastDateDisabled=true;
this.isAsanaConsumedDisabled=true;
this.isAsanaIdealDisabled=true;
this.isAsanaMissedDisabled=true;
this.isAsanaPercentageDisabled=true;
this.isTriphalaComplianceDisabled=true;
this.isTriphalaFirstDateDisabled=true;
this.isTriphalaLastDateDisabled=true;
this.isTriphalaConsumedDisabled=true;
this.isTriphalaIdealDisabled=true;
this.isTriphalaMissedDisabled=true;
this.isTriphalaPercentageDisabled=true;
this.isYavaComplianceDisabled=true;
this.isYavaFirstDateDisabled=true;
this.isYavaLastDateDisabled=true;
this.isYavaConsumedDisabled=true;
this.isYavaIdealDisabled=true;
this.isYavaMissedDisabled=true;
this.isYavaPercentageDisabled=true;
this.isAsanaDispensedDisabled=true;
this.isAsanaQuantityDisabled=true;
this.isAsanaRetrievedDisabled=true;
this.isTriphalaDispensedDisabled=true;
this.isTriphalaQuantityDisabled=true;
this.isTriphalaRetrievedDisabled=true;
this.isYavaDispensedDisabled=true;
this.isYavaQuantityDisabled=true;
this.isYavaRetrievedDisabled=true;
this.isDispensedProtocolDisabled=true;
this.isLogGivenDisabled=true;
this.isDispensingDateDisabled=true;
this.isAsanaSachetsDisabled=true;
this.isAsanaStudyDisabled=true;
this.isAsanaBatchDisabled=true;
this.isAsanaExpiryDisabled=true;
this.isTriphalaSachetsDisabled=true;
this.isTriphalaStudyDisabled=true;
this.isTriphalaBatchDisabled=true;
this.isTriphalaExpiryDisabled=true;
this.isYavaSachetsDisabled=true;
this.isYavaStudyDisabled=true;
this.isYavaBatchDisabled=true;
this.isYavaExpiryDisabled=true;

   
      this.editReason = '';
      },
      error: (error) => {
        console.error("Error submitting form:", error);
        alert("Error submitting form. Please try again.");
      }
    });
  }

  goBack() {
    this.router.navigate(['/study-details', this.studyId]);
  }
  createField() {
    alert("Create Field Clicked!");
  }
}